'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _ = require('../../');

var _DefaultString = require('../../../helpers/DefaultString');

var _Popup = require('../../../helpers/Popup');

var _popup = require('../../../redux/modules/popup');

var _Product = require('../../../helpers/Product');

var _CreatePasswordAndLinkToProfileSuccess = require('./CreatePasswordAndLinkToProfileSuccess.scss');

var _CreatePasswordAndLinkToProfileSuccess2 = _interopRequireDefault(_CreatePasswordAndLinkToProfileSuccess);

var _Router = require('../../../helpers/Router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreatePasswordAndLinkToProfileSuccess = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth, type: state.popup.type };
}, { closePopup: _popup.closePopup }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(CreatePasswordAndLinkToProfileSuccess, _Component);

  function CreatePasswordAndLinkToProfileSuccess() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CreatePasswordAndLinkToProfileSuccess);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CreatePasswordAndLinkToProfileSuccess.__proto__ || (0, _getPrototypeOf2.default)(CreatePasswordAndLinkToProfileSuccess)).call.apply(_ref, [this].concat(args))), _this), _this.closePopup = function () {
      _this.props.closePopup();
      window.location.replace((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.LoginEmail));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CreatePasswordAndLinkToProfileSuccess, [{
    key: 'render',
    value: function render() {
      var formatMessage = this.props.intl.formatMessage;

      var buttonTheme = _Popup.Popup.buttonTheme(this.props.auth.productName);
      var productName = this.props.auth.productName;


      var popupBackgroundStyle = void 0;
      switch (productName) {
        case _Product.PRODUCT_NAMES.Music:
          popupBackgroundStyle = _CreatePasswordAndLinkToProfileSuccess2.default.music;
          break;
        case _Product.PRODUCT_NAMES.Classica:
          popupBackgroundStyle = _CreatePasswordAndLinkToProfileSuccess2.default.classica;
          break;
        case _Product.PRODUCT_NAMES.Qello:
          popupBackgroundStyle = _CreatePasswordAndLinkToProfileSuccess2.default.qello;
          break;
        default:
          popupBackgroundStyle = '';
      }
      return _react2.default.createElement(
        'div',
        { className: [_CreatePasswordAndLinkToProfileSuccess2.default.createPasswordAndLinkToProfileSuccess, popupBackgroundStyle].join(' ') },
        _react2.default.createElement(
          'div',
          { className: _CreatePasswordAndLinkToProfileSuccess2.default.title },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.Success)
        ),
        _react2.default.createElement(
          'div',
          { className: _CreatePasswordAndLinkToProfileSuccess2.default.message },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, _DefaultString.translations.CreatePasswordAndLinkToProfileSuccess, {
            values: { product: formatMessage((0, _Product.getProductName)(this.props.auth.realm, this.props.auth.productName, this.props.auth.clientId)) }
          }))
        ),
        _react2.default.createElement(_.BaseButton, { onClick: this.closePopup, buttonString: _DefaultString.translations.Ok, className: _CreatePasswordAndLinkToProfileSuccess2.default.okButton, theme: buttonTheme })
      );
    }
  }]);
  return CreatePasswordAndLinkToProfileSuccess;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  closePopup: _react.PropTypes.func,
  intl: _reactIntl.intlShape.isRequired
}, _class2.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired,
  location: _react2.default.PropTypes.object
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(CreatePasswordAndLinkToProfileSuccess);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/CreatePasswordAndLinkToProfileSuccess/CreatePasswordAndLinkToProfileSuccess.js
// module id = 1970
// module chunks = 0